function veda_fn_0c8a23ecf6b142719637a9b50dd4f8cc () {
      
  if (window.veda_fn_0c8a23ecf6b142719637a9b50dd4f8ccCleanup === undefined) {
    window.veda_fn_0c8a23ecf6b142719637a9b50dd4f8ccCleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_0c8a23ecf6b142719637a9b50dd4f8ccCleanup.cleanup();

      try {
        const uniqueId = "id_039e933d-b272-493e-93f8-d343efdfb3d1";
        const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
        containers.forEach(container => {
          if (!container) {
            return;
          }
          veda.plugins.videoCover(container);
          
        });
      } catch(error) {
        console.error(error);
      }
    }
veda_fn_0c8a23ecf6b142719637a9b50dd4f8cc();
function veda_fn_7ebdb493112d4b51abee9f954221ba62 () {
      
  if (window.veda_fn_7ebdb493112d4b51abee9f954221ba62Cleanup === undefined) {
    window.veda_fn_7ebdb493112d4b51abee9f954221ba62Cleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_7ebdb493112d4b51abee9f954221ba62Cleanup.cleanup();

      try {
        const uniqueId = "id_2a7c1c74-4de5-4a00-8e65-215f7094f86c";
        const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
        containers.forEach(container => {
          if (!container) {
            return;
          }
          veda.plugins.videoCover(container);
          const {
  productCompare,
  productWishList,
  sticky,
  select,
  mobileMenu,
  predictiveSearch,
} = veda.plugins;
const comparePopupEls = container.querySelectorAll(".veda-compare-toggle-js");
const wishlistToggleEls = container.querySelectorAll(
  ".veda-wishlist-badge-toggle-js"
);

const stickyEl = container.querySelector(".veda-sticky");

let visibleSearch = false;

function getSectionBackground(defaultValue) {
  const vedaBackgroundEl = container.querySelector(".veda-background");
  if (vedaBackgroundEl && vedaBackgroundEl.style.backgroundColor) {
    return vedaBackgroundEl.style.backgroundColor;
  }
  return defaultValue;
}

function containerZIndex() {
  function handleContainerClick() {
    container.style.zIndex = "999";
  }

  function handleWindowClick(event) {
    if (!container.contains(event.target)) {
      container.style.removeProperty("z-index");
    }
  }
  container.addEventListener("click", handleContainerClick);
  window.addEventListener("click", handleWindowClick);

  window.veda_fn_7ebdb493112d4b51abee9f954221ba62Cleanup.push(() => {
    container.removeEventListener("click", handleContainerClick);
    window.removeEventListener("click", handleWindowClick);
  });
}
containerZIndex();

function navigation() {
  const compares = Array.from(comparePopupEls).map((element) => ({
    element,
    label: `<span class="ml:10px">Compare</span>`,
    className:
      "w:100% p:15px pl:5px! h:50px d:flex ai:center ff:font-secondary fz:13px fw:500 tt:uppercase c:color-gray9 ta:left",
  }));
  const wishLists = Array.from(wishlistToggleEls).map((element) => ({
    element,
    label: `<span class="ml:10px">Wishlist</span>`,
    className:
      "w:100% p:15px pl:5px! h:50px d:flex ai:center ff:font-secondary fz:13px fw:500 tt:uppercase c:color-gray9 ta:left",
  }));
  const appendElements = [].concat(compares, wishLists);
  const menu = mobileMenu(container, {
    backClassName: "p:15px bdb:1px_solid_color-gray2",
    closeClassName: "w:100% p:8px_15px bdb:1px_solid_color-gray2",
    appendElements,
  });

  function checkResponsive() {
    if (window.innerWidth > 992) {
      menu.destroy();
    } else {
      menu.init();
    }
  }
  checkResponsive();
  window.addEventListener("resize", checkResponsive);
  window.veda_fn_7ebdb493112d4b51abee9f954221ba62Cleanup.push(() => {
    window.removeEventListener("resize", checkResponsive);
  });
}
navigation();

function currency() {
  const selectEls = container.querySelectorAll(".veda-select-currency");
  selectEls.forEach((selectEl) => {
    if (selectEl) {
      const formEl = container.querySelector(".currency_form");
      const currencyCodeEl = container.querySelector('[name="currency_code"]');
      const flagEl = selectEl.querySelector(".veda-select__view .flag");
      select(selectEl, {
        onChange(value) {
          flagEl.className = `mr:5px flag flag-${value}`;
          if (!builderMode) {
            currencyCodeEl.setAttribute("value", value);
            formEl.submit();
          }
        },
      });
    }
  });
}
currency();

function language() {
  const selectEls = container.querySelectorAll(".veda-select-lang");
  selectEls.forEach((selectEl) => {
    if (selectEl) {
      const formEl = container.querySelector(".localization_form");
      const localeCodeEl = container.querySelector('[name="locale_code"]');
      select(selectEl, {
        onChange(value) {
          if (!builderMode) {
            localeCodeEl.setAttribute("value", value);
            formEl.submit();
          }
        },
      });
    }
  });
}
language();

function setBadbe(el, count) {
  if (count) {
    el.textContent = count;
    el.style.setProperty("display", "flex", "important");
  } else {
    el.style.removeProperty("display");
  }
}

function compare() {
  comparePopupEls.forEach((comparePopupEl) => {
    const compareOptionsData = veda.utils.objectParse(
      comparePopupEl.getAttribute("data-options")
    );
    const compareOptionsTitle =
      compareOptionsData.compareOptionsTitle.split(",");
    productCompare.customCompare({
      ...compareOptionsData,
      compareOptionsTitle: compareOptionsTitle,
    });
    //button popup
    const handleClick = () => {
      productCompare.togglePopup();
    };
    comparePopupEl.addEventListener("click", handleClick);
    // compare badge
    const compareBadgeEl = comparePopupEl.querySelector(
      ".veda-compare-badge-js"
    );
    setBadbe(compareBadgeEl, productCompare.getData().length);
    const unsubscribe = productCompare.subscribe((state) => {
      setBadbe(compareBadgeEl, state.length);
    });
    window.veda_fn_7ebdb493112d4b51abee9f954221ba62Cleanup.push(() => {
      unsubscribe();
      comparePopupEl.removeEventListener("click", handleClick);
    });
  });
}
compare();

function wishList() {
  const wishlistBadgeEls = container.querySelectorAll(
    ".veda-wishlist-badge-js"
  );
  wishlistBadgeEls.forEach((wishlistBadgeEl) => {
    const count = productWishList.getData()?.length;
    setBadbe(wishlistBadgeEl, count);

    const unsubscribe = productWishList.subscribe((state) => {
      const count = state.length;
      setBadbe(wishlistBadgeEl, count);
    });

    window.veda_fn_7ebdb493112d4b51abee9f954221ba62Cleanup.push(() => {
      unsubscribe();
    });
  });
}
wishList();

function search() {
  const btnSearchEls = container.querySelectorAll(".btn-search-js");
  const searchContent = container.querySelector(".search-content-js");
  const inputSearchEl = container.querySelector(".input-search-js");
  if (!!btnSearchEls) {
    btnSearchEls.forEach((btnSearchEl) => {
      const handleClick = () => {
        if (visibleSearch) {
          inputSearchEl.blur();
          searchContent.style.transform = "translateY(-100%)";
          searchContent.style.visibility = "hidden";
          visibleSearch = false;
        } else {
          inputSearchEl.focus();
          searchContent.style.transform = "translateY(0)";
          searchContent.style.visibility = "visible";
          visibleSearch = true;
        }
      };
      btnSearchEl.addEventListener("click", handleClick);
      window.veda_fn_7ebdb493112d4b51abee9f954221ba62Cleanup.push(() => {
        btnSearchEl.removeEventListener("click", handleClick);
      });
    });
  }
}
search();

let isSticky = false;
function headerSticky() {
  if (stickyEl) {
    const destroy = sticky(stickyEl, {
      onChange(sticky) {
        if (sticky !== isSticky) {
          if (sticky) {
            stickyEl.style.backgroundColor =
              getSectionBackground("var(--color-light)");
          } else {
            stickyEl.style.removeProperty("background-color");
          }
          isSticky = sticky;
        }
      },
    });
    window.veda_fn_7ebdb493112d4b51abee9f954221ba62Cleanup.push(() => {
      destroy();
    });
  }
}

function handlePredictiveSearch() {
  const el = container.querySelector(".veda-search-form-js");
  const resultText = el.getAttribute("data-text-result");
  let predictiveSearchOptions;
  if (!!resultText) {
    predictiveSearchOptions = {
      viewAllText: resultText,
      position: "fixed",
    };
  } else {
    predictiveSearchOptions = {
      position: "fixed",
    };
  }
  const destroy = predictiveSearch(el, predictiveSearchOptions);
  window.veda_fn_7ebdb493112d4b51abee9f954221ba62Cleanup.push(() => {
    destroy();
  });
}

headerSticky();
handlePredictiveSearch();
        });
      } catch(error) {
        console.error(error);
      }
    }
veda_fn_7ebdb493112d4b51abee9f954221ba62();
function veda_fn_da77956b0aa142479f58885a5928722b () {
      
  if (window.veda_fn_da77956b0aa142479f58885a5928722bCleanup === undefined) {
    window.veda_fn_da77956b0aa142479f58885a5928722bCleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_da77956b0aa142479f58885a5928722bCleanup.cleanup();

      try {
        const uniqueId = "id_504b3b2c-fb76-419e-878c-8db25ca1db81";
        const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
        containers.forEach(container => {
          if (!container) {
            return;
          }
          veda.plugins.videoCover(container);
          let loading = false;
const {
  cart,
  productWishList,
  productCompare,
  photoSwipe,
  message,
  toggleGroup,
  swiper,
  imageZoom,
} = veda.plugins;
const {
  objectParse,
  imageUrl,
  getObjectAttributes,
  random,
  store,
  findAtomicCss,
} = veda.utils;
let iconType = "";

const wishListDataEl = container.querySelector(".product-card-data-js");
const productData = objectParse(wishListDataEl.textContent);
let initialPickUp = false;
store.create("@visiblePickup", {
  initialState: false,
});

let unsubscribePickUp = () => {};

store.create("@@productRecentlyViewed", {
  initialState: [],
  useStorage: true,
});
let productRecentlyViewed = store.get("@@productRecentlyViewed");
if (productRecentlyViewed?.length) {
  productRecentlyViewed = productRecentlyViewed.filter(
    (item) => item !== `id:${productData.id}`
  );
  store.set("@@productRecentlyViewed", () => {
    return [`id:${productData.id}`, ...productRecentlyViewed];
  });
} else {
  store.set("@@productRecentlyViewed", () => {
    return [`id:${productData.id}`];
  });
}
class PageProduct {
  constructor() {
    this.data = productData;
    this.option = productData.selected_or_first_available_variant.options;
    this.variantId = productData.selected_or_first_available_variant.id;
    this.toggleGroup = [];
    this.pickupLoading = false;
    this.swipper = swiper(container.querySelector(".veda-swiper-product-media"));
    this.init();
  }

  async handleClickDraw() {
    if (builderMode) {
      const pickUpEl = container.querySelector(".pickup-js");
      const overlayEl = pickUpEl.querySelector(".pickup-close-js");
      overlayEl.classList.remove("pe:none", "op:0");
      initialPickUp = true;
      store.set("@visiblePickup", true);
    } else {
      initialPickUp = true;
      store.set("@visiblePickup", true);
    }
  }

  handleUpdateJsPickUp(el) {
    const btnPickUpCloseEls = el.querySelectorAll(".pickup-close-js");
    btnPickUpCloseEls.forEach((btnPickUpCloseEl) => {
      const handleClick = () => {
        store.set("@visiblePickup", false);
      };
      btnPickUpCloseEl.addEventListener("click", handleClick);
      window.veda_fn_da77956b0aa142479f58885a5928722bCleanup.push(() => {
        btnPickUpCloseEl.removeEventListener("click", handleClick);
      });
    });
  }

  async updatePickUp() {
    const btnTogglePickUp = container.querySelector(".veda-pickup-toggle-js");
    if (!!btnTogglePickUp) {
      try {
        const res = await fetch(`${this.data.url}?variant=${this.variantId}`);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, "text/html");
        const pickupContainerEl = doc.querySelector(".pickup-container-js");
        const pickupInformationEl = doc.querySelector(
          ".pickup-availability-information"
        );
        const newContainerHtml = pickupContainerEl.innerHTML;
        const newInformationHtml = pickupInformationEl.innerHTML;
        const realEl = container.querySelector(".pickup-container-js");
        const realInformationEl = container.querySelector(
          ".pickup-availability-information"
        );
        realEl.innerHTML = newContainerHtml;
        realInformationEl.innerHTML = newInformationHtml;
        const testEl = document.querySelector(".pickup-draw-js");
        if (!testEl) {
          const contentPickUp = document.createElement("div");
          contentPickUp.className = "pickup-draw-js pos:relative z:9999999";
          const pickUpContentEl = container.querySelector(".pickup-js");
          contentPickUp.innerHTML = pickUpContentEl.innerHTML;
          handleUpdateJsPickUp(contentPickUp);
        } else {
          const pickUpContentEl = container.querySelector(".pickup-js");
          testEl.innerHTML = pickUpContentEl.innerHTML;
          handleUpdateJsPickUp(testEl);
        }
        const currentBtn = realInformationEl.querySelector(
          ".veda-pickup-toggle-js"
        );
        currentBtn.addEventListener("click", this.handleClickDraw);
        window.veda_fn_da77956b0aa142479f58885a5928722bCleanup.push(() => {
          currentBtn.removeEventListener("click", this.handleClickDraw);
        });
        this.pickupLoading = false;
        findAtomicCss(newContainerHtml);
        findAtomicCss(newInformationHtml);
      } catch (e) {
        console.log(e);
      }
    }
  }

  handleChangeVariant(variant, changeSlide) {
    const btnAddCart = container.querySelector(".product-card-add-js");
    const btnBuyNow = container.querySelector(".btn-buy-now-js");
    if (!!variant) {
      if (variant.available) {
        btnAddCart?.classList?.remove(..."pe:none op:0.5".split(" "));
        const btnCartText = btnAddCart?.querySelector(".veda-button-text");
        const cartAvailableText = container.getAttribute("data-available-text");
        if (!!btnCartText && cartAvailableText) {
          btnCartText.textContent = cartAvailableText;
        }
      } else if (!btnAddCart?.classList?.contains("pe:none")) {
        btnAddCart?.classList?.add(..."pe:none op:0.5".split(" "));
        const btnCartText = btnAddCart?.querySelector(".veda-button-text");
        const cartUnavailableText = container.getAttribute(
          "data-unavailable-text"
        );
        if (!!btnCartText && cartUnavailableText) {
          btnCartText.textContent = cartUnavailableText;
        }
      }
      btnBuyNow?.parentNode?.classList?.remove(..."pe:none op:0.5".split(" "));
      const availableEl = container.querySelector(".veda-product-available-js");
      const skuEl = container.querySelector(".veda-product-sku-js");
      const priceEl = container.querySelector(".product-content-price-js");
      availableEl?.classList?.remove("d:none");
      skuEl?.classList?.remove("d:none");
      if (!!priceEl) {
        priceEl?.classList?.remove("d:none!");
        priceEl?.classList?.remove("d:none");
      }
      const currentSelectedIdEl = container.querySelector(
        ".veda-product-variant-select-id-js"
      );
      const currentTermSelectedIdEl = container.querySelector(
        ".veda-payment-term-id"
      );
      const slideEls = container.querySelectorAll("[data-media-id]");
      if (slideEls.length) {
        const variantPosition = Array.from(slideEls).findIndex(
          (slideEl) =>
            slideEl.getAttribute("data-media-id") == variant?.featured_media?.id
        );
        if (changeSlide && variantPosition != -1) {
          this.swipper?.slideTo(variantPosition);
        }
      }
      this.variantId = variant.id;
      currentSelectedIdEl.value = `${this.variantId}`;
      if (!!currentTermSelectedIdEl) {
        currentTermSelectedIdEl.value = `${this.variantId}`;
      }
      if (!builderMode && !this.pickupLoading) {
        this.pickupLoading = true;
        this.updatePickUp();
      }
      // change available
      if (!!availableEl) {
        const availableTitle = availableEl.getAttribute("data-title");
        const availableInStockText =
          availableEl.getAttribute("data-instock-text");
        const availableOutOfStockText = availableEl.getAttribute(
          "data-outofstock-text"
        );
        if (variant.available && variant.inventory_quantity != 0) {
          const inStockText = availableInStockText.replace(
            /\d+/g,
            `${variant.inventory_quantity}`
          );
          availableEl.textContent = `${availableTitle}: ${inStockText}`;
        } else {
          availableEl.textContent = `${availableTitle}: ${availableOutOfStockText}`;
        }
      }

      // change price
      if (!!priceEl) {
        const onSaleEl = priceEl.querySelector(".product-price-on-sale-js");
        const notSaleEl = priceEl.querySelector(".product-price-not-sale-js");
        if (
          Number(variant.veda_compare_at_price) > Number(variant.veda_price)
        ) {
          const regularPrice = onSaleEl.querySelector("ins");
          const salePrice = onSaleEl.querySelector("del");
          onSaleEl.classList.remove("d:none!");
          onSaleEl.classList.remove("d:none");
          if (
            !notSaleEl.classList.contains("d:none") &&
            !notSaleEl.classList.contains("d:none")
          ) {
            notSaleEl.classList.add("d:none!");
          }
          regularPrice.innerHTML = variant.price;
          salePrice.innerHTML = variant.compare_at_price;
        } else {
          notSaleEl.classList.remove("d:none!");
          notSaleEl.classList.remove("d:none");
          if (
            !onSaleEl.classList.contains("d:none") &&
            !onSaleEl.classList.contains("d:none!")
          ) {
            onSaleEl.classList.add("d:none!");
          }
          notSaleEl.innerHTML = variant.price;
        }
      }
      if (!!skuEl && !!variant.sku) {
        skuEl.textContent = `SKU: ${variant.sku}`;
      }
      this.data?.options_with_values?.forEach((option) => {
        const titleEl = container.querySelector(
          `.veda-option-title-${option.position}`
        );
        if (!!titleEl) {
          titleEl.textContent = `${option.name}: ${
            this.option[option.position - 1]
          }`;
        }
      });
    } else {
      const availableEl = container.querySelector(".veda-product-available-js");
      const skuEl = container.querySelector(".veda-product-sku-js");
      const priceEl = container.querySelector(".product-content-price-js");
      if (!btnAddCart?.classList?.contains("pe:none")) {
        btnAddCart?.classList?.add(..."pe:none op:0.5".split(" "));
        const btnCartText = btnAddCart?.querySelector(".veda-button-text");
        const cartUnavailableText = container.getAttribute(
          "data-unavailable-text"
        );
        if (!!btnCartText && cartUnavailableText) {
          btnCartText.textContent = cartUnavailableText;
        }
      }
      if (!!btnBuyNow && !btnBuyNow?.classList?.contains?.("pe:none")) {
        btnBuyNow.parentNode.classList.add(..."pe:none op:0.5".split(" "));
      }
      if (!availableEl?.classList?.contains?.("d:none") && !!availableEl) {
        availableEl?.classList?.add("d:none");
      }
      if (!!skuEl && !skuEl?.classList?.contains("d:none")) {
        skuEl?.classList?.add("d:none");
      }
      if (
        !priceEl?.classList?.contains("d:none") &&
        !priceEl?.classList?.contains("d:none!") &&
        !!priceEl
      ) {
        priceEl.classList.add("d:none!");
      }
      this.data?.options_with_values?.forEach((option) => {
        const titleEl = container.querySelector(
          `.veda-option-title-${option.position}`
        );
        titleEl.textContent = `${option.name}: ${
          this.option[option.position - 1]
        }`;
      });
    }
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.data.variants.filter(
      (variant) => this.option[0] === variant.options[0]
    );
    const toggleEls = container.querySelectorAll(".veda-toggle-group");
    toggleEls.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll(".veda-toggle-group__item"),
      ];
      const previousOptionSelected = this.option[index - 1];
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant.options[`${index - 1}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption.options[`${index}`]);
      optionInputs.forEach((input) => {
        if (
          availableOptionInputsValue.includes(input.getAttribute("data-value"))
        ) {
          input.style.display = "block";
        } else {
          input.style.display = "none";
        }
      });
    });
  }

  handleChangeSlide() {
    const checkEl = container.querySelector(".veda-toggle-group-1");
    if (!this.data.has_only_default_variant && !!checkEl) {
      this.data.options_with_values.forEach((option, index) => {
        const activeIndex = option.values.findIndex(
          (item) => item == this.option[index]
        );
        this.toggleGroup[index].go(activeIndex);
      });
    }
  }

  handleSelectOption() {
    const checkEl = container.querySelector(".veda-toggle-group-1");
    const colorOptionEl = container.querySelector("[data-color-option]");
    if (!this.data.has_only_default_variant && !!checkEl) {
      this.data.options_with_values.forEach((option) => {
        const position = Number(option.position) - 1;
        const currentActiveIndex = option.values.findIndex(
          (item) => item === option.selected_value
        );
        const el = container.querySelector(
          `.veda-toggle-group-${option.position}`
        );
        const itemDataCss = getObjectAttributes(
          el.getAttribute("data-item-css")
        );
        const itemActiveDataCss = getObjectAttributes(
          el.getAttribute("data-item-active-css")
        );
        let classItemAdd = "c:color-light bgc:color-gray9";
        let classItemRemove = "c:color-gray9 bgc:color-gray2";
        if (option.name === "Color" && !!colorOptionEl) {
          classItemAdd = "bd:1px_solid_color-gray9";
          classItemRemove = "bd:1px_solid_color-gray3";
        }
        const currentToggle = toggleGroup(el, {
          activeIndex: Number(currentActiveIndex),
          onChange: (index) => {
            const itemEls = el.querySelectorAll(".veda-toggle-group__item");
            this.option.splice(position, 1, option.values[index]);
            const currentVariant = this.data.variants.filter(
              (variant) =>
                variant.options.length === this.option.length &&
                variant.options.every((value, index) => {
                  return value === this.option[index];
                })
            )[0];
            this.handleChangeVariant(currentVariant, true);
            this.updateVariantStatuses();
            itemEls.forEach((itemEl, currentIndex) => {
              if (index != currentIndex) {
                itemEl.setAttribute("data-css", itemDataCss["data-css"]);
              }
            });
            itemEls[index].setAttribute(
              "data-css",
              itemActiveDataCss["data-css"]
            );
          },
          addClassName: classItemAdd,
          removeClassName: classItemRemove,
        });
        this.toggleGroup = [...this.toggleGroup, currentToggle];
      });
    }
  }

  checkHasItem(productData, storeData) {
    return storeData?.some((item) => item.id === productData.id);
  }

  changeStatus(el, hasItem) {
    if (!el) {
      return;
    }
    /** @type HTMLElement */
    const iconEl = el.querySelector('i[class^="fa"]');
    if (!iconType) {
      iconType = Array.from(iconEl.classList).find((className) =>
        /fa\w/g.test(className)
      );
    }
    if (hasItem()) {
      el.setAttribute("data-tooltip-active", true);
      el.style.setProperty("color", "var(--color-primary)", "important");
      if (iconType.includes("fa")) {
        iconEl.classList.remove(iconType);
        iconEl.classList.add("fas");
      }
    } else {
      el.setAttribute("data-tooltip-active", false);
      el.style.removeProperty("color");
      if (iconType.includes("fa")) {
        iconEl.classList.remove("fas");
        iconEl.classList.add(iconType);
      }
    }
    return hasItem;
  }

  handleQuantity() {
    const quantityEl = container.querySelector(".veda-counter");
    if (!quantityEl) {
      return;
    }
    veda.plugins.counter(container, {
      min: 1,
      max: Infinity,
      step: 1,
      value: 1,
      onChange: (value) => {},
    });
  }

  handleWishList() {
    const btnWishListEl = container.querySelector(".wishlist-toggle-js");
    const wishListDataEl = container.querySelector(".product-card-data-js");
    const productData = objectParse(wishListDataEl.textContent);
    if (!btnWishListEl) {
      return;
    }
    const hasItem = () =>
      this.checkHasItem(productData, productWishList.getData());
    this.changeStatus(btnWishListEl, hasItem);
    const handleClick = () => {
      const hasItem = () =>
        this.checkHasItem(productData, productWishList.getData());
      const addText = btnWishListEl.getAttribute("data-add-text");
      const removeText = btnWishListEl.getAttribute("data-remove-text");
      productWishList.toggleWishList(productData);
      this.changeStatus(btnWishListEl, hasItem);
      if (hasItem()) {
        message.success(addText);
      } else {
        message.error(removeText);
      }
    };
    btnWishListEl.addEventListener("click", handleClick);
    let unsubscribeWishList = productWishList.subscribe((state) => {
      const btnWishListEl = container.querySelector(".wishlist-toggle-js");
      const wishListDataEl = container.querySelector(".product-card-data-js");
      const productData = objectParse(wishListDataEl.textContent);
      const hasItem = () => this.checkHasItem(productData, state);
      this.changeStatus(btnWishListEl, hasItem);
    });
    window.veda_fn_da77956b0aa142479f58885a5928722bCleanup.push(() => {
      unsubscribeWishList();
      btnWishListEl.removeEventListener("click", handleClick);
    });
  }

  handleCompare() {
    const btnCompareEl = container.querySelector(".compare-toggle-js");
    const compareDataEl = container.querySelector(".product-card-data-js");
    const productData = objectParse(compareDataEl.textContent);
    const ratingCustom = container.querySelector(".compare-rating-js");
    if (!btnCompareEl) {
      return;
    }
    const hasItem = () =>
      this.checkHasItem(productData, productCompare.getData());
    this.changeStatus(btnCompareEl, hasItem);
    const handleClick = () => {
      productCompare.toggleProduct({
        ...productData,
        rating: ratingCustom?.innerHTML,
      });
      const addText = btnCompareEl.getAttribute("data-add-text");
      const removeText = btnCompareEl.getAttribute("data-remove-text");
      this.changeStatus(btnCompareEl, hasItem);
      if (hasItem()) {
        addText && message.success(addText);
      } else {
        removeText && message.error(removeText);
      }
    };
    btnCompareEl.addEventListener("click", handleClick);
    window.veda_fn_da77956b0aa142479f58885a5928722bCleanup.push(() => {
      btnCompareEl.removeEventListener("click", handleClick);
    });
    let unsubscribeCompare = productCompare.subscribe((state) => {
      const btnCompareEl = container.querySelector(".compare-toggle-js");
      const compareDataEl = container.querySelector(".product-card-data-js");
      const productData = objectParse(compareDataEl.textContent);
      const hasItem = () => this.checkHasItem(productData, state);
      this.changeStatus(btnCompareEl, hasItem);
    });
    window.veda_fn_da77956b0aa142479f58885a5928722bCleanup.push(() => {
      unsubscribeCompare();
    });
  }

  addCartSuccess(el) {
    const check = `
      <svg class="checkmark w:14px h:14px mr:10px bdrs:50% d:block stkw:2 stk:#fff stroke-miterlimit:10 bxsh:inset_0px_0px_0px_#7ac142 anim:fill_0.4s_ease-in-out_0.4s_forwards,scale_0.3s_ease-in-out_0.9s_both" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
        <circle class='checkmark__circle sd:166 stroke-dasharray:166 stkw:2 stroke-miterlimit:10 stk:#7ac142 fill:none anim:stroke_0.6s_cubic-bezier(0.65,0,0.45,1)_forwards' cx='26' cy='26' r='25' fill='none'/> 
        <path class='checkmark__check trfo:50%_50% stroke-dasharray:48 sd::48 anim:stroke_0.3s_cubic-bezier(0.65,0,0.45,1)_0.8s_forwards' fill='none' d='M14.1 27.2l7.1 7.2 16.7-16.8'/>
      </svg>`;
    el.insertAdjacentHTML("afterbegin", check);
    setTimeout(() => {
      const checkEl = el.querySelector(".checkmark");
      const iconEl = el.querySelector(".product-cart-add-icon-js");
      if (!!checkEl) {
        checkEl.remove();
        iconEl?.style?.removeProperty("display");
      }
      loading = false;
    }, 2000);
  }

  handleAddCart() {
    const btnAddCart = container.querySelector(".product-card-add-js");
    if (!btnAddCart) {
      return;
    }
    const handleClick = (event) => {
      event.preventDefault();
      if (!loading) {
        const iconEl = btnAddCart.querySelector(".product-cart-add-icon-js");
        const quantityEl =
          container.querySelector(
            "input[name='quantity']:checked.veda-buy_more_save-more-quantity"
          ) || container.querySelector(".veda-product-quantity-js");
        loading = true;
        const spinner =
          "<div class='veda-spinner bdw:2px mr:10px' style='--spinner-color: var(--color-light-freeze); --spinner-size: 14px'></div>";
        btnAddCart.insertAdjacentHTML("afterbegin", spinner);
        if (iconEl) {
          iconEl.style.display = "none";
        }
        if (builderMode) {
          setTimeout(() => {
            const currentSpinner = btnAddCart.querySelector(".veda-spinner");
            currentSpinner.remove();
            this.addCartSuccess(btnAddCart);
          }, 2000);
        } else {
          let addToCartForm = container.querySelector(
            `#product-add-cart-${uniqueId}`
          );
          let formData = new FormData(addToCartForm);
          fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            body: formData,
          })
            .then((response) => {
              const currentSpinner = btnAddCart.querySelector(".veda-spinner");
              currentSpinner.remove();
              this.addCartSuccess(btnAddCart);
              return response.json();
            })
            .catch((error) => {
              const currentSpinner = btnAddCart.querySelector(".veda-spinner");
              currentSpinner.remove();
              loading = false;
              // message.error(error?.description);
            });
        }
      }
    };
    if (!builderMode) {
      const formCart = container.querySelector(`#product-add-cart-${uniqueId}`);
      formCart.addEventListener("submit", handleClick);
      window.veda_fn_da77956b0aa142479f58885a5928722bCleanup.push(() => {
        formCart.removeEventListener("submit", handleClick);
      });
    }
  }

  handleViewing() {
    const viewingEl = container.querySelector(".quantity-viewing-js");
    if (!viewingEl) {
      return;
    }
    const min = viewingEl.getAttribute("data-min");
    const max = viewingEl.getAttribute("data-max");
    const text = viewingEl.getAttribute("data-text");
    const time = viewingEl.getAttribute("data-time");
    const intervalID = setInterval(() => {
      viewingEl.textContent = `${text.replace(
        /\d/g,
        `${random(Number(min), Number(max))}`
      )}`;
    }, Number(time) * 1000);
    window.veda_fn_da77956b0aa142479f58885a5928722bCleanup.push(() => {
      clearInterval(intervalID);
    });
  }

  handleDOM() {
    this.handleSelectOption();
    this.handleQuantity();
    this.handleWishList();
    this.handleCompare();
    this.handleAddCart();
    this.handleViewing();
    this.updateVariantStatuses();
  }

  init() {
    this.handleDOM();
    this.handleChangeSlide();
  }
}
function initAddonMobile() {
  const addonDesktop = container.querySelector(
    ".veda-product-information-addon-desktop"
  );
  const addonDesktopContent = container.querySelector(
    ".veda-product-information-addon-desktop-content"
  );
  const addonMobile = container.querySelector(
    ".veda-product-information-addon-mobile"
  );
  if (window.innerWidth < 992) {
    addonMobile.innerHTML = "";
    addonMobile.insertAdjacentElement("afterbegin", addonDesktopContent);
  } else {
    addonMobile.innerHTML = "";
    addonDesktop.innerHTML = "";
    addonDesktop.insertAdjacentElement("afterbegin", addonDesktopContent);
  }
}

initAddonMobile();
window.addEventListener("resize", initAddonMobile);
new PageProduct();
const photo = photoSwipe({
  gallery: ".veda-photo-swipe",
});
const destroyZoom = imageZoom(container);
window.veda_fn_da77956b0aa142479f58885a5928722bCleanup.push(() => {
  photo();
  destroyZoom();
  window.removeEventListener("resize", initAddonMobile);
});

const { createIntersectionObserver } = veda.utils;

const intersectionObserver = createIntersectionObserver({
  rootMargin: "0px",
});
const videoEls = container.querySelectorAll("video");
videoEls.forEach((videoEl) => {
  function handleVideo(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        videoEl.play();
      } else {
        videoEl.pause();
      }
    });
  }
  intersectionObserver.addListener(handleVideo, videoEl);
  window.veda_fn_da77956b0aa142479f58885a5928722bCleanup.push(() => {
    intersectionObserver.removeListener(handleVideo);
  });
});
if (!builderMode) {
  const glbInitId = setTimeout(() => {
    window.GPOConfigs?.loadMainScripts?.(
      GPOConfigs?.featuredProduct,
      GPOConfigs?.form
    );
    clearTimeout(glbInitId);
  }, 2000);
}

if (!builderMode) {
  const linkEls = document.querySelectorAll("a[data-pswp-width]");
  linkEls.forEach((linkEl) => {
    linkEl.addEventListener("click", (event) => event.preventDefault());
  });
}
        });
      } catch(error) {
        console.error(error);
      }
    }
veda_fn_da77956b0aa142479f58885a5928722b();
function veda_fn_f12ebf90252b4f09b775d187f27128b9 () {
      
  if (window.veda_fn_f12ebf90252b4f09b775d187f27128b9Cleanup === undefined) {
    window.veda_fn_f12ebf90252b4f09b775d187f27128b9Cleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_f12ebf90252b4f09b775d187f27128b9Cleanup.cleanup();

      try {
        const uniqueId = "id_6ac586af-b02e-41bf-b541-c6883d1533ce";
        const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
        containers.forEach(container => {
          if (!container) {
            return;
          }
          veda.plugins.videoCover(container);
          const instance = veda.plugins.swiper(container);
window.veda_fn_f12ebf90252b4f09b775d187f27128b9Cleanup.push(() => {
  instance.destroy();
});
        });
      } catch(error) {
        console.error(error);
      }
    }
veda_fn_f12ebf90252b4f09b775d187f27128b9();
function veda_fn_dee50941dabd44919897d14f4d13798e () {
      
  if (window.veda_fn_dee50941dabd44919897d14f4d13798eCleanup === undefined) {
    window.veda_fn_dee50941dabd44919897d14f4d13798eCleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_dee50941dabd44919897d14f4d13798eCleanup.cleanup();

      try {
        const uniqueId = "id_ef7d2d4b-06cd-4741-996a-5f4e3ba18959";
        const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
        containers.forEach(container => {
          if (!container) {
            return;
          }
          veda.plugins.videoCover(container);
          const { collapse } = veda.plugins;
collapse(container, {
  activeClass: "collapse-active",
});
        });
      } catch(error) {
        console.error(error);
      }
    }
veda_fn_dee50941dabd44919897d14f4d13798e();
function veda_fn_4735fe6906604cdab1b7daaf110cb8c5 () {
      
  if (window.veda_fn_4735fe6906604cdab1b7daaf110cb8c5Cleanup === undefined) {
    window.veda_fn_4735fe6906604cdab1b7daaf110cb8c5Cleanup = {
      listeners: [],
      push(listener) {
        this.listeners.push(listener);
      },
      cleanup() {
        this.listeners.forEach(listener => listener());
        this.listeners = [];
      }
    }
  }
  window.veda_fn_4735fe6906604cdab1b7daaf110cb8c5Cleanup.cleanup();

      try {
        const uniqueId = "id_3037bef5-edd9-483c-948c-45de2a09098b";
        const containers = document.querySelectorAll(`[data-id="${uniqueId}"]`);
        containers.forEach(container => {
          if (!container) {
            return;
          }
          veda.plugins.videoCover(container);
          const { getObjectAttributes, storage } = veda.utils;
const tabEl = container.querySelector(".veda-tabs");
const cssLink = getObjectAttributes(tabEl.getAttribute("tabs-data-css"));
const cssActiveLink = getObjectAttributes(
  tabEl.getAttribute("tabs-data-css-active")
);
const tabLinkEls = tabEl.querySelectorAll(".veda-tabs__link");

function handleChange(els, currentIndex) {
  els.forEach((el, index) => {
    if (index != currentIndex) {
      el.setAttribute("data-css", cssLink["data-css"]);
    }
  });
  els[currentIndex].setAttribute("data-css", cssActiveLink["data-css"]);
}

const instance = veda.plugins.tabs(tabEl, {
  activeIndex: Number(storage.getItem("current-tab-detail")) || 0,
  onChange: (currentIndex) => {
    handleChange(tabLinkEls, currentIndex);
    if (builderMode) {
      storage.setItem("current-tab-detail", `${currentIndex}`);
    }
  },
});
if (builderMode) {
  instance.go(Number(storage.getItem("current-tab-detail")) || 0);
}
window.veda_fn_4735fe6906604cdab1b7daaf110cb8c5Cleanup.push(() => {
  instance.destroy();
});

function handleActiveAddOn() {
  const paneItems = container.querySelectorAll(".veda-tabs__pane");
  const currentIndexTab =
    Array.from(paneItems)?.findIndex(
      (item) => !!item?.querySelector(".veda-review_widget")
    ) || 0;
  if (
    Array.from(paneItems)?.findIndex(
      (item) => !!item?.querySelector(".veda-review_widget")
    ) != -1
  ) {
    const starRatingEls = document.querySelectorAll(
      ".veda-review-addon_rating[href='veda-review-addon']"
    );
    starRatingEls.forEach((starRatingEl) => {
      starRatingEl.removeAttribute("href");
    });
  }
  const ratingItem = document.querySelector(".veda-review_rating");
  const reviewItem = document.querySelector(".veda-review_widget");
  const hasReviewItem = container.querySelector(".veda-review_widget");
  if (!!ratingItem && !!reviewItem && !!hasReviewItem) {
    function handleClickAddon() {
      const currentSection = reviewItem.closest("section");
      instance.go(Number(currentIndexTab));
      const id = setTimeout(() => {
        if (!!currentSection) {
          window.scrollTo({
            top: currentSection.getBoundingClientRect().top,
            behavior: "smooth",
          });
        } else {
          window.scrollTo({
            top: reviewItem.getBoundingClientRect().top,
            behavior: "smooth",
          });
        }
        clearTimeout(id);
      }, 300);
    }
    ratingItem.addEventListener("click", handleClickAddon, true);
    window.veda_fn_4735fe6906604cdab1b7daaf110cb8c5Cleanup.push(() => {
      ratingItem.removeEventListener("click", handleClickAddon, true);
    });
  }
}
handleActiveAddOn();

if (builderMode) {
  function handleMessage(event) {
    if (event.data?.type == "Veda:AddonToggle") {
      const currentSection = document.querySelector(
        `[data-id="${event.data?.payload?.sectionIds?.[0]}"`
      );
      if (!!currentSection) {
        const paneItems = container.querySelectorAll(".veda-tabs__pane");
        const currentIndexTab = Array.from(paneItems)?.findIndex(
          (item) =>
            !!item?.querySelector(`[data-id="${event.data?.payload?.id}"]`)
        );
        if (currentIndexTab) {
          if (instance.index != currentIndexTab) {
            instance.go(Number(currentIndexTab));
          }
        }
        const id = setTimeout(() => {
          const currentSection1 = document.querySelector(
            `[data-id="${event.data?.payload?.sectionIds?.[0]}"`
          );
          window.scrollTo({
            top: currentSection1.getBoundingClientRect().top,
            behavior: "smooth",
          });
          clearTimeout(id);
        }, 300);
      }
    }
  }
  window.addEventListener("message", handleMessage);
  window.veda_fn_4735fe6906604cdab1b7daaf110cb8c5Cleanup.push(() => {
    window.removeEventListener("message", handleMessage);
  });
}
        });
      } catch(error) {
        console.error(error);
      }
    }
veda_fn_4735fe6906604cdab1b7daaf110cb8c5();